// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
})();


// Theme JS //
  const partnerDivs = document.querySelectorAll(".partner-div");

  partnerDivs.forEach((div) => {
    div.addEventListener("click", function () {
      const isFullWidth = div.classList.contains("full-width");

      const hiddenText = div.querySelector(".hidden-text");
      hiddenText.classList.toggle("show-text");

      const image = div.querySelector("img");
      image.classList.toggle("float-end");

      if (image.classList.contains("float-end")) {
        image.style.width = "130px";
      } else {
        image.style.width = "";
      }

      div.classList.toggle("full-width");

      if (!isFullWidth) {
        partnerDivs.forEach((otherDiv) => {
          if (otherDiv !== div) {
            otherDiv.classList.add("hide-div");
          }
        });
      } else {
        partnerDivs.forEach((otherDiv) => {
          otherDiv.classList.remove("hide-div");
        });
      }
    });
  });


const popUpTrigger = document.querySelector('.popup-trigger');

const closeButton = document.querySelector('.btn-close');

popUpTrigger.addEventListener('click', () => {
  closeButton.click();
});


document.addEventListener("DOMContentLoaded", function () {
  var links = document.querySelectorAll(
    'a[href="/#anspruch"], a[href="/#beantragung"], a[href="/#uberuns"], a[href="/#warumsani25"]'
  );

  links.forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault();

      const closeButton = document.querySelector(".btn-close");
      closeButton.click();

      window.location.href = link.getAttribute("href");
    });
    });
});